import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import imgEstudios1 from "../../assets/tests/scn3/retro-1.jpg";
import imgEstudios2 from "../../assets/tests/scn3/retro-2.jpg";
import imgEstudios3 from "../../assets/tests/scn3/retro-3.jpg";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { IconVocabulary } from "@tabler/icons-react";
import flechaRetroceder from "../../assets/left-arrow.svg";
import flechaAvanzar from "../../assets/right-arrow.svg";

function Scenario3Retroalimentacion({ intl }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const activeScenario = 4;

  // 👇 estado para manejar qué slide está activo
  const [currentIndex, setCurrentIndex] = useState(0);

  // Array de imágenes
  const images = [imgEstudios2, imgEstudios3];

  const handleNext = () => {
    if (currentIndex < images.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      navigate(ROUTES.SCENARIO3_FIN2, { state: { activeScenario } });
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const titles = [
    "Valoración geriátrica de Manuel",
    "Inicio del tratamiento"
  ];


  const texts = [
    "Paciente prefrágil, ambulatorio, con inestabilidad para la marcha, con síndrome de caídas, con alta probabilidad para sarcopenia. Con riesgo de malnutrición</br>No integra síndrome depresivo. Pfeiffer 2 errores. Sin <i>delirium</i>.",
    "El paciente inició tratamiento con apalutamida 240 mg/día.</br>Con esta etapa completada, es momento de avanzar y enfrentar los nuevos desafíos que surgen en su seguimiento clínico."
  ];

  return (
    <div className="h-100">
      <div className="container-fluid h-100">
        <div className="row h-100">
          {/* Columna izquierda con retroalimentación */}
          <div
            className="col-md-5 d-flex justify-content-start align-items-center ps-5 pt-5"
            style={{ marginBottom: "2vh" }}
          >
            <div className="d-flex flex-column align-items-start w-100">
              <h3 className="txt30 violet bold">
                {titles[currentIndex]}
              </h3>
              <p
                className="position-relative txtTexto1 mt-3"
                style={{
                  padding: "20px",
                  lineHeight: "1.6",
                  border: "1px solid #8c3888",
                  borderRadius: "8px",
                  overflow: "hidden",
                  height: "270px",
                  width: "100%",
                }}
              >
                <div
                    className="position-relative"
                    dangerouslySetInnerHTML={{ __html: texts[currentIndex] }}
                />
              </p>

              {/* Dots indicadores */}
              <div className="d-flex justify-content-center align-items-center mt-2 w-100">
                {images.map((_, idx) => (
                  <div
                    key={idx}
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      margin: "0 4px",
                      backgroundColor: idx === currentIndex ? "#8c3888" : "#ccc",
                    }}
                  ></div>
                ))}
              </div>

              {/* Botones de navegación */}
              <div className="d-flex justify-content-between mt-3 w-100">
                {currentIndex > 0 ? (
                <div className="d-flex justify-content-end align-items-center">
                  <button
                  onClick={handlePrev}
                    className="btn-main bgViolet"
                    style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    }}
                  >
                    <img
                    src={flechaRetroceder}
                    alt="Anterior"
                    style={{ maxWidth: "30px" }}
                    />
                  </button>
                  <div className="txt24 txtRed bold ms-3 violet">
                    Anterior
                  </div>           
                </div>
                ) : (
                  <div style={{ width: "50px" }}></div>
                )}
                <div className="d-flex justify-content-end align-items-center">
                  <div className="txt24 txtRed bold me-3 violet">
                    Siguiente
                  </div>
                  <button
                    onClick={handleNext}
                    className={`btn-main bold txt22 bgViolet`}
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                    }}
                  >
                      <img
                      src={flechaAvanzar  }
                      alt="Anterior"
                      style={{ maxWidth: "30px" }}
                      />
                  </button>             
                </div>
              </div>
            </div>
          </div>

          {/* Columna derecha con imágenes */}
          <div className="col-md-7 d-flex justify-content-center align-items-center pe-0">
            <img
              src={images[currentIndex]}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              alt="Estudio"
            />
          </div>
        </div>
      </div>

      {/* Barra inferior */}
      <ScenarioBar activeScenario={activeScenario} />
    </div>
  );
}

export default injectIntl(Scenario3Retroalimentacion);
